export default ['Broadcast', 'Cable', 'Digital Platform', 'Premium Cable', 'Streaming'];
